var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{class:_vm.classByVote(_vm.value),attrs:{"icon":_vm.iconByVote(_vm.value),"fixed-width":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }